import { Reveal, SectionHeading } from "../components/Reveal";
import { METHOD_STEPS } from "../lib/protocols";

export default function MetodoSection() {
  return (
    <section id="metodo" className="section" data-testid="metodo-section">
      <div className="container-hub">
        <div className="grid items-end gap-10 md:grid-cols-[1.3fr_1fr]">
          <SectionHeading
            eyebrow="Il metodo"
            title={<>NON UN SERVIZIO. <span className="gold-text">UN METODO.</span></>}
          />
          <Reveal delay={0.2}>
            <p className="border-l border-gold py-5 pl-6 text-[17px] leading-relaxed text-[#d1d1d1]" data-testid="metodo-note">
              La complessità viene gestita da noi. Il cliente vede solo il percorso, con ordine e trasparenza.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 border border-[#c9a45c]/22 bg-[#c9a45c]/22 sm:grid-cols-2 lg:grid-cols-6">
          {METHOD_STEPS.map((step, i) => (
            <Reveal
              key={step.n}
              delay={i * 0.07}
              className="bg-[#0b0b0b] transition-colors duration-300 hover:bg-[#111]"
            >
              <div className="flex min-h-[218px] flex-col p-6" data-testid={`metodo-step-${step.n}`}>
                <span className="font-mono text-[11px] tracking-[0.16em] text-gold">{step.n}</span>
                <h3 className="mt-9 text-[13px] font-bold tracking-[0.1em] text-cream">{step.title}</h3>
                <p className="mt-2.5 text-[13px] leading-relaxed text-[#929292]">{step.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
